import React, { Fragment } from "react";
import { Popover, Transition, Disclosure } from "@headlessui/react";
import { ChevronDown, Menu, X } from "lucide-react";
import { Link, NavLink } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const products = [
  {
    name: "EasyBooks Accounting",
    description: "Financial management made simple",
    to: "/EasyBooks_Accounting",
  },
  {
    name: "EasyBooks ERP",
    description: "Complete business management",
    to: "/EasyBooks_ERP",
  },
  {
    name: "EasyBooks IMERIS",
    description: "Healthcare management system",
    to: "/EasyBooks_IMERIS",
  },
];

const services = [
  {
    name: "Software Development",
    description: "Custom applications & solutions",
    to: "/SoftwareDevelopment",
  },
  {
    name: "Business Process Re-engineering",
    description: "Optimize your workflows",
    to: "/BRP",
  },
];

const about = [
  { name: "Overview", description: "Our company story", to: "/About" },
  { name: "Success Stories", description: "Client achievements", to: "/SuccessStories" },
  { name: "The Team", description: "Meet our experts", to: "/Team" },
];

const desktopLinkBase =
  "px-4 py-2 text-sm font-semibold rounded-xl transition-colors duration-200";

export default function Navbar() {
  return (
    <Popover className="fixed top-0 left-0 right-0 z-50 border-b border-slate-200/60 bg-white/80 backdrop-blur-md">
      <div className="eb-container">
        <div className="flex h-20 items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="logo-dark.png" alt="EasyBooks" className="h-10 w-auto" />
          </Link>

          {/* Desktop */}
          <nav className="hidden lg:flex items-center gap-1">
            <NavLink
              exact
              to="/"
              className={classNames(
                desktopLinkBase,
                "text-slate-700 hover:text-brand-700 hover:bg-slate-50"
              )}
              activeClassName="text-brand-800 bg-brand-50"
            >
              Home
            </NavLink>

            <Popover className="relative">
              {({ open }) => (
                <>
                  <Popover.Button
                    className={classNames(
                      desktopLinkBase,
                      "flex items-center gap-1 text-slate-700 hover:text-brand-700 hover:bg-slate-50",
                      open && "text-brand-800 bg-brand-50"
                    )}
                  >
                    Products
                    <ChevronDown
                      className={classNames(
                        "h-4 w-4 transition-transform duration-200",
                        open && "rotate-180"
                      )}
                      aria-hidden="true"
                    />
                  </Popover.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                  >
                    <Popover.Panel className="absolute left-0 top-full mt-3 w-80 rounded-2xl border border-slate-200 bg-white p-2 shadow-soft">
                      {products.map((item) => (
                        <Link
                          key={item.to}
                          to={item.to}
                          className="block rounded-xl px-4 py-3 hover:bg-brand-50 focus:bg-brand-50"
                        >
                          <div className="text-sm font-semibold text-slate-900">{item.name}</div>
                          <div className="text-sm text-slate-600">{item.description}</div>
                        </Link>
                      ))}
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>

            <Popover className="relative">
              {({ open }) => (
                <>
                  <Popover.Button
                    className={classNames(
                      desktopLinkBase,
                      "flex items-center gap-1 text-slate-700 hover:text-brand-700 hover:bg-slate-50",
                      open && "text-brand-800 bg-brand-50"
                    )}
                  >
                    Services
                    <ChevronDown
                      className={classNames(
                        "h-4 w-4 transition-transform duration-200",
                        open && "rotate-180"
                      )}
                      aria-hidden="true"
                    />
                  </Popover.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                  >
                    <Popover.Panel className="absolute left-0 top-full mt-3 w-96 rounded-2xl border border-slate-200 bg-white p-2 shadow-soft">
                      {services.map((item) => (
                        <Link
                          key={item.to}
                          to={item.to}
                          className="block rounded-xl px-4 py-3 hover:bg-brand-50 focus:bg-brand-50"
                        >
                          <div className="text-sm font-semibold text-slate-900">{item.name}</div>
                          <div className="text-sm text-slate-600">{item.description}</div>
                        </Link>
                      ))}
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>

            <Popover className="relative">
              {({ open }) => (
                <>
                  <Popover.Button
                    className={classNames(
                      desktopLinkBase,
                      "flex items-center gap-1 text-slate-700 hover:text-brand-700 hover:bg-slate-50",
                      open && "text-brand-800 bg-brand-50"
                    )}
                  >
                    About
                    <ChevronDown
                      className={classNames(
                        "h-4 w-4 transition-transform duration-200",
                        open && "rotate-180"
                      )}
                      aria-hidden="true"
                    />
                  </Popover.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                  >
                    <Popover.Panel className="absolute left-0 top-full mt-3 w-80 rounded-2xl border border-slate-200 bg-white p-2 shadow-soft">
                      {about.map((item) => (
                        <Link
                          key={item.to}
                          to={item.to}
                          className="block rounded-xl px-4 py-3 hover:bg-brand-50 focus:bg-brand-50"
                        >
                          <div className="text-sm font-semibold text-slate-900">{item.name}</div>
                          <div className="text-sm text-slate-600">{item.description}</div>
                        </Link>
                      ))}
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>

            <NavLink
              to="/Clients"
              className={classNames(
                desktopLinkBase,
                "text-slate-700 hover:text-brand-700 hover:bg-slate-50"
              )}
              activeClassName="text-brand-800 bg-brand-50"
            >
              Clients
            </NavLink>

            <NavLink to="/Contact" className="eb-btn-primary ml-2" activeClassName="">
              Contact
            </NavLink>
          </nav>

          {/* Mobile button */}
          <div className="lg:hidden">
            <Popover.Button className="inline-flex items-center justify-center rounded-xl p-2 hover:bg-slate-100 transition-colors">
              <span className="sr-only">Open menu</span>
              <Menu className="h-6 w-6 text-slate-700" aria-hidden="true" />
            </Popover.Button>
          </div>
        </div>
      </div>

      {/* Mobile panel */}
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 -translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 -translate-y-2"
      >
        <Popover.Panel className="lg:hidden border-t border-slate-200/60 bg-white">
          {({ close }) => (
            <div className="eb-container py-4">
              <div className="flex items-center justify-between">
                <div className="text-sm font-semibold text-slate-900">Menu</div>
                <button
                  type="button"
                  className="rounded-xl p-2 hover:bg-slate-100 transition-colors"
                  onClick={() => close()}
                >
                  <span className="sr-only">Close menu</span>
                  <X className="h-6 w-6 text-slate-700" aria-hidden="true" />
                </button>
              </div>

              <div className="mt-4 space-y-1">
                <NavLink
                  exact
                  to="/"
                  onClick={() => close()}
                  className="block rounded-xl px-4 py-3 text-slate-700 font-semibold hover:bg-slate-50"
                  activeClassName="bg-brand-50 text-brand-800"
                >
                  Home
                </NavLink>

                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-xl px-4 py-3 text-slate-700 font-semibold hover:bg-slate-50">
                        Products
                        <ChevronDown
                          className={classNames(
                            "h-4 w-4 transition-transform",
                            open && "rotate-180"
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="space-y-1 px-2 pb-2">
                        {products.map((item) => (
                          <NavLink
                            key={item.to}
                            to={item.to}
                            onClick={() => close()}
                            className="block rounded-xl px-4 py-2 text-slate-600 hover:bg-brand-50 hover:text-brand-800"
                            activeClassName="bg-brand-50 text-brand-800"
                          >
                            {item.name}
                          </NavLink>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>

                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-xl px-4 py-3 text-slate-700 font-semibold hover:bg-slate-50">
                        Services
                        <ChevronDown
                          className={classNames(
                            "h-4 w-4 transition-transform",
                            open && "rotate-180"
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="space-y-1 px-2 pb-2">
                        {services.map((item) => (
                          <NavLink
                            key={item.to}
                            to={item.to}
                            onClick={() => close()}
                            className="block rounded-xl px-4 py-2 text-slate-600 hover:bg-brand-50 hover:text-brand-800"
                            activeClassName="bg-brand-50 text-brand-800"
                          >
                            {item.name}
                          </NavLink>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>

                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-xl px-4 py-3 text-slate-700 font-semibold hover:bg-slate-50">
                        About
                        <ChevronDown
                          className={classNames(
                            "h-4 w-4 transition-transform",
                            open && "rotate-180"
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="space-y-1 px-2 pb-2">
                        {about.map((item) => (
                          <NavLink
                            key={item.to}
                            to={item.to}
                            onClick={() => close()}
                            className="block rounded-xl px-4 py-2 text-slate-600 hover:bg-brand-50 hover:text-brand-800"
                            activeClassName="bg-brand-50 text-brand-800"
                          >
                            {item.name}
                          </NavLink>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>

                <NavLink
                  to="/Clients"
                  onClick={() => close()}
                  className="block rounded-xl px-4 py-3 text-slate-700 font-semibold hover:bg-slate-50"
                  activeClassName="bg-brand-50 text-brand-800"
                >
                  Clients
                </NavLink>

                <NavLink to="/Contact" onClick={() => close()} className="eb-btn-primary w-full mt-3">
                  Contact
                </NavLink>
              </div>
            </div>
          )}
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}